import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { isNullOrUndefined } from 'util';
import { JournalInsertModel, tJournalModel } from 'src/app/models/tJournalModel';
import {tRecurrJnlModel,RecurrJnlInsertModel,RecurrJnlPageSelectModel,RecurrJnlEditPageSearchResultModel}from 'src/app/models/tRecurrJnlModel';
import {tRecurrJnlService} from 'src/app/services/tRecurrJnl.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { TranslateService } from '@ngx-translate/core';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { DatePipe } from '@angular/common';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { SnackBarService } from 'src/app/services/SnackBar/SnackBarService.service';
@Component({
  selector: 'app-voucher-search',
  templateUrl: './voucher-search.component.html',
  styleUrls: ['./voucher-search.component.css']
})
export class VoucherSearchComponent implements OnInit {
  TAG = "VoucherSearchComponent";


  editForm: FormGroup;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;



  dataSource: MatTableDataSource<RecurrJnlPageSelectModel>;
  checkLoadingDataSource: any;
  dataList: RecurrJnlPageSelectModel[];
  retuenData:RecurrJnlEditPageSearchResultModel=new RecurrJnlEditPageSearchResultModel();
  //loading spinner
  deleteOnClick=false;
  isLoading = true;

  displayedColumns: string[] = [
    'deleteBtn',
    'recurrID',
    'recurrName',
    'vouType',
    'jnlDate',
    'totalAmount'
  ];


  filteredValues = {
    recurrID: '', recurrName: ''
  };
  recurrFilter = new FormControl();

  constructor(
    private snackBarService: SnackBarService,
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    private recurrJnlService:tRecurrJnlService,
    private apiResultDialogService: ApiResultDialogService,
    public datePipe: DatePipe,
  ) { }

  ngOnInit() {
    this.getAllData();
  }

  cancel() {
    this.activeModal.close();
  }

  getAllData(): void{
      
  
      this.recurrJnlService.getAllRecurrData(NavigationComponent.selectedShopID.toString()).subscribe(data => {
      this.dataList = data;
 
      this.dataSource = new MatTableDataSource<RecurrJnlPageSelectModel>(this.dataList);
      this.dataSource.paginator = this.paginator;  
      //loading spinner
      this.isLoading = false;
      this.checkLoadingDataSource = data;
      //table sort
      this.dataSource.sort = this.sort;

      this.recurrFilter.valueChanges.subscribe((value) => {
        this.filteredValues['recurrID'] = value;
        this.filteredValues['recurrName'] = value;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.dataSource.filterPredicate = this.customFilterPredicate();
      
      },
        error => this.isLoading = false);
    
  }
  selectedRecord(selectedModel: RecurrJnlPageSelectModel) {
    if(this.deleteOnClick==false){
    this.log.i(this.TAG, "selectedRecord data = " + selectedModel.recurrID);
    this.recurrJnlService.getRecurrData(selectedModel.recurrID).subscribe(data => {
    this.activeModal.close(data);
    });
    }
    this.deleteOnClick=false;

  }

  customFilterPredicate() {
    const myFilterPredicate = (data: RecurrJnlPageSelectModel, filter: string): boolean => {

      const searchString = JSON.parse(filter);

      return ((searchString.recurrID.toLowerCase() === '' ||
      (data.recurrID != null && data.recurrID.toString().trim().toLowerCase().indexOf(searchString.recurrID.toLowerCase()) !== -1))
      ||
      (searchString.recurrName.toLowerCase() === '' ||
        (data.recurrName != null
          && data.recurrName.toString().trim().toLowerCase().indexOf(searchString.recurrName.toLowerCase()) !== -1))
    );
      
    };
    return myFilterPredicate;
  }

  openDialog(status, msg) {
    return this.apiResultDialogService.openDialog(status, '', status, msg);
  }

  delete(model: RecurrJnlPageSelectModel) {
    this.deleteOnClick=true;

    const dialogRef = this.openDialog(MastersKeyStringValue.ACTION_YNDialog, "確定刪除 ");

    dialogRef.result.then((result) => {
      if (result === 'Y') {
        this.recurrJnlService.deleteRecurrJnl(model.recurrID).subscribe((data: any) => {

          this.snackBarService.showDeleteSuccess();
          this.getAllData();
        });

      }

    }, (reason) => {
      // on dismiss
    });
    
  }

}
